import React from "react";
import { Link } from "react-router-dom";
import logoWhite from "../../../assets/images/logo/logo-white.svg";
import facebook from "../../../assets/images/social2/facebook.svg";
import github from "../../../assets/images/social2/github.svg";
import instagram from "../../../assets/images/social2/instagram.svg";
import twitter from "../../../assets/images/social2/twitter.svg";
import mail from "../../../assets/images/svg2/mail.svg";
import map from "../../../assets/images/svg2/map.svg";
import phone from "../../../assets/images/svg2/phone.svg";

export default function FooterHomeFive() {
	return (
		<footer className="fugu--footer-section">
			<div className="container">
				<div className="fugu--footer-top">
					<div className="row">
						<div className="col-lg-3">
							<div className="fugu--textarea">
								<div className="fugu--footer-logo">
									<img src={logoWhite} alt="" className="light-version-logo" />
								</div>
								<p>
									Discover NFTs by category, track the latest drops, and follow the collections you
									love to enjoy it!
								</p>
								<div className="fugu--social-icon fugu--social-icon3">
								<ul>
										<li>
											<Link to={"#"}>
												<img src={twitter} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={facebook} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={instagram} alt="" />
											</Link>
										</li>
										<li>
											<Link to={"#"}>
												<img src={github} alt="" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="col-lg-2 offset-lg-1 col-md-4 col-sm-4">
							<div className="fugu--footer-menu">
								<span>Marketplace</span>
								<ul>
									<li>
										<Link to="#">Create A Store</Link>
									</li>
									<li>
										<Link to="#">Start Selling</Link>
									</li>
									<li>
										<Link to="#">My Account</Link>
									</li>
									<li>
										<Link to="#">Job</Link>
									</li>
									<li>
										<Link to="#">List a Item</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-2 offset-lg-1 col-md-4 col-sm-4">
							<div className="fugu--footer-menu">
								<span>Marketplace</span>
								<ul>
									<li>
										<Link to="#">Art</Link>
									</li>
									<li>
										<Link to="#">Digital Art</Link>
									</li>
									<li>
										<Link to="#">Photography</Link>
									</li>
									<li>
										<Link to="#">Games</Link>
									</li>
									<li>
										<Link to="#">Music</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-2 offset-lg-1 col-md-4 col-sm-4">
							<div className="fugu--footer-menu">
								<span>Marketplace</span>
							</div>
							<div className="fugu--info">
								<ul>
									<li>
										<Link to="#">
											<img src={phone} alt="" />
											+088-234-6534
										</Link>
									</li>
									<li>
										<Link to="#">
											<img src={mail} alt="" />
											example@gmail. com
										</Link>
									</li>
									<li>
										<Link to="#">
											<img src={map} alt="" />
											6391 Elgin St. Celina, New York City.
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div className="fugu--footer-bottom fugu--footer-bottom3">
					<div className="row">
						<div className="col-lg-6">
							<p>&copy; Copyright 2022, All Rights Reserved by Mthemeus</p>
						</div>
						<div className="col-lg-6">
							<div className="fugu--footer-menu">
								<ul>
									<li>
										<Link to="#">Terms</Link>
									</li>
									<li>
										<Link to="#"> Privacy Policy</Link>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
